// Roles are stored as snake_case keys. Never render the raw key to a human.
const ROLE_LABELS = {
  super_admin: 'Super Admin',
  data_admin: 'Data Admin',
  model_admin: 'Model Admin',
  analyst: 'Analyst',
  viewer: 'Viewer',
  public: 'Public',
}

// Falls back to title-casing the key, so a role added on the backend still reads
// as words rather than as `some_new_role`.
export function roleLabel(role) {
  if (!role) return '—'
  return (
    ROLE_LABELS[role] ||
    String(role)
      .split('_')
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  )
}

export default roleLabel
